export default "__VITE_ASSET__9f10366d__"